import type {
  UserTokenContext,
  SESSION_TYPE, AuthorizationInfo, ErrorAndResultCallbackFn, UserSignOutPayload
} from '@cimpress-technology/authfront-sdk-core'

type UrlParam = { key: string; value: string }

enum NavHint {
  SignUp = 'signUp',
  SignInVcsSSO = 'signInVcsSSO'

}

type UserSignInOptions = {
  allowGuestUser?: boolean;
  guestReturnUrl?: string;
  site?: string;
  skipFasterCheckoutText?: boolean;
  loginContext?: string;
  navHint?: NavHint;
  enableGoogleOneTap?: boolean;
  enforcedEmail?: string;
  customText?: string;
  isFirstLogin?: boolean;
  isSteppedUp?: boolean;
  unificationEntityId?: string;
  vcsStoreUrl?: string;
  testUserId?: string;
  storeId?: string;
  vcsStoreLogoUrl?: string;
  restrictSignup?: boolean;
  disableEmailField?: boolean;
  trackingCaller?: string;
}

type UserIdentityEvent = {
  profile: object | null;
  isSignedIn: boolean;
  canonicalId: string | null;
  accessToken?: string | null;
  recentAnonymousIds: string[];
  authorizationHeader?: string | null;
  authorization: AuthorizationInfo;
  referenceToken: string | null;
}

export {
  NavHint,
  type SESSION_TYPE,
  type UserTokenContext,
  type AuthorizationInfo,
  type UserSignOutPayload,
  type UserSignInOptions,
  type ErrorAndResultCallbackFn,
  type UserIdentityEvent,
  type UrlParam
}
